import React from 'react'
import { CONTENT_FLAGS } from '../lib/contentFlags'
import './Packages.css'

// ─────────────────────────────────────────────────────────────────────────────
// Software Packages page
// Coming-soon state — purchase flow wired when content ships
// Flip CONTENT_FLAGS.PACKAGES_LIVE in src/lib/contentFlags.js when ready
// ─────────────────────────────────────────────────────────────────────────────

const PACKAGES_LIVE = CONTENT_FLAGS.PACKAGES_LIVE

const PACKAGES = [
  {
    id:      'web_design',
    name:    'Web & Design Fundamentals',
    badge:   'First package',
    tag:     'Premium',
    desc:    'For IT professionals who get asked to fix the website. HTML, CSS, and JavaScript basics, WordPress administration, VS Code, browser DevTools, basic Git, and design fundamentals with Figma and Canva.',
    tools:   ['HTML & CSS', 'JavaScript basics', 'WordPress', 'VS Code', 'Browser DevTools', 'Git basics', 'Figma', 'Canva'],
    lessons: '~30 lessons',
    price:   '€24.99',
  },
  {
    id:      'programming_fundamentals',
    name:    'Programming Fundamentals',
    badge:   null,
    tag:     'Premium',
    desc:    'For IT professionals who want to understand code without becoming developers. Python basics, scripting for automation, reading and understanding code, and working with APIs.',
    tools:   ['Python basics', 'Scripting', 'Automation', 'APIs', 'Reading code', 'Command line'],
    lessons: '~30 lessons',
    price:   '€24.99',
  },
]

const COMING_SOON_PACKAGES = [
  { name: 'ServiceNow Fundamentals',     desc: 'ITSM administration, workflows, and incident management in ServiceNow.' },
  { name: 'Microsoft Intune',            desc: 'Device enrolment, compliance policies, app deployment, and conditional access.' },
  { name: 'Splunk Core',                 desc: 'Log ingestion, search, dashboards, and alerting in Splunk.' },
  { name: 'Microsoft Sentinel',          desc: 'SIEM fundamentals, analytics rules, incidents, and workbooks.' },
  { name: 'Power BI Fundamentals',       desc: 'Data modelling, DAX basics, report building, and dashboard publishing.' },
]

export function Packages() {
  return (
    <div className="packages-page">
      <div className="packages-header">
        <div className="packages-header__eyebrow mono">Add-on packages</div>
        <h1 className="packages-header__title">Software Packages</h1>
        <p className="packages-header__sub">
          Tool-specific content as a one-time purchase — €24.99 per package, yours while your subscription is active.
          Built around the platforms IT professionals actually work with.
        </p>
      </div>

      {!PACKAGES_LIVE && (
        <div className="packages-coming-banner">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
          </svg>
          <span>Software packages are in development. Web & Design Fundamentals ships first — after Foundation reaches full capacity.</span>
        </div>
      )}

      {/* Main packages */}
      <div className="packages-grid">
        {PACKAGES.map(pkg => (
          <PackageCard key={pkg.id} pkg={pkg} live={PACKAGES_LIVE} />
        ))}
      </div>

      {/* On the roadmap */}
      <div className="packages-roadmap">
        <div className="packages-roadmap__label mono">On the roadmap</div>
        <div className="packages-roadmap__grid">
          {COMING_SOON_PACKAGES.map(pkg => (
            <div key={pkg.name} className="roadmap-card">
              <div className="roadmap-card__name">{pkg.name}</div>
              <div className="roadmap-card__desc">{pkg.desc}</div>
              <div className="roadmap-card__tag mono">Coming soon</div>
            </div>
          ))}
        </div>
        <p className="packages-roadmap__note">
          Packages are built based on what TechBench users actually need on the job.
          More added over time — priorities driven by demand.
        </p>
      </div>
    </div>
  )
}

function PackageCard({ pkg, live }) {
  return (
    <div className={`pkg-card ${live ? '' : 'pkg-card--soon'}`}>
      {pkg.badge && (
        <div className="pkg-card__badge">{pkg.badge}</div>
      )}
      <div className="pkg-card__tag-row">
        <span className="pkg-card__tag mono">{pkg.tag}</span>
      </div>
      <div className="pkg-card__name">{pkg.name}</div>
      <div className="pkg-card__desc">{pkg.desc}</div>

      <div className="pkg-card__tools">
        {pkg.tools.map(t => (
          <span key={t} className="pkg-card__tool mono">{t}</span>
        ))}
      </div>

      <div className="pkg-card__footer">
        <div className="pkg-card__lessons mono">{pkg.lessons}</div>
        <div className="pkg-card__price">{pkg.price}</div>
      </div>

      {live ? (
        <button className="pkg-card__cta">
          Unlock — {pkg.price}
        </button>
      ) : (
        <button className="pkg-card__cta pkg-card__cta--soon" disabled>
          Coming soon
        </button>
      )}

      <div className="pkg-card__note mono">
        One-time purchase · Requires active subscription
      </div>
    </div>
  )
}
